<script setup lang="ts">
import { useId } from 'vue'

type TOption = {
  value: string | number
  label: string
}

const props = withDefaults(defineProps<{
  options?: TOption[]
  selectedOption?: string | null | number
  label?: string
  disabled?: boolean
  name?: string
  required?: boolean
}>(), {
  options: [] as TOption[],
  disabled: false,
  required: false,
})

const emits = defineEmits<{
  'update:selectedOption': (value: string | number) => void
}>()

const generatedName = useId()
const groupName = () => props.name || generatedName
</script>

<template>
  <fieldset class="border-0 p-0 m-0 min-w-0">
    <slot name="label">
      <legend v-if="label" class="subtitle text-sm px-0 float-none w-full mb-0">
        {{ label }} <span v-if="required" class="text-danger-400" aria-hidden="true">*</span>
      </legend>
    </slot>
    <div class="flex flex-wrap gap-4">
      <label v-for="option in options" :key="option.value" class="flex items-center gap-2">
        {{ option.label }}
        <input
          :class="[{ 'cursor-not-allowed': disabled }]"
          :disabled="disabled"
          type="radio"
          :name="groupName()"
          :value="option.value"
          :checked="selectedOption == option.value"
          :aria-required="required || undefined"
          :data-cy="`bradio-option-${option.value}`"
          @change="emits('update:selectedOption', option.value)"
        >
      </label>
    </div>
  </fieldset>
</template>
